import { Language } from '../language';
import admin from './admin';
import ads from './ads';
import agent from './agent';
import api from './api';
import artists from './artists';
import auth from './auth';
import carpools from './carpools';
import common from './common';
import dataImport from './dataImport';
import editor from './editor';
import history from './history';
import imagePicker from './imagePicker';
import infos from './infos';
import maps from './maps';
import news from './news';
import notifications from './notifications';
import pages from './pages';
import places from './places';
import reports from './reports';
import roles from './roles';
import settings from './settings';
import shows from './shows';
import tickets from './tickets';
import users from './users';
import versions from './versions';

/**
 * Every message, one namespace per area. Each namespace file holds `en` and `fr` side by side, and types `fr` as
 * `typeof en`, so a message missing from one language doesn't compile.
 */
const catalog = {
  admin,
  ads,
  agent,
  api,
  artists,
  auth,
  carpools,
  common,
  dataImport,
  editor,
  history,
  imagePicker,
  infos,
  maps,
  news,
  notifications,
  pages,
  places,
  reports,
  roles,
  settings,
  shows,
  tickets,
  users,
  versions,
};

export type Namespace = keyof typeof catalog;
export type Messages<N extends Namespace> = typeof catalog[N]['en'];

export const messagesOf = <N extends Namespace>(language: Language, namespace: N): Messages<N> =>
  catalog[namespace][language] as Messages<N>;

/** Every namespace's messages in one language, for the tests that compare the two */
export const catalogOf = (language: Language) =>
  Object.fromEntries(Object.entries(catalog).map(([namespace, messages]) => [namespace, messages[language]]));
